export const UserActionRequired = {
  postage: 1,
  productionNote: 2,
  font: 3,
  duplicates: 4,
  unapproved: 5
}
